export default "/images/6bc293a88c8f6e3e9e4c22b00f9c6f46.avif";